import { render, staticRenderFns } from "./jsonSettings.vue?vue&type=template&id=72815db6&"
import script from "./jsonSettings.vue?vue&type=script&lang=js&"
export * from "./jsonSettings.vue?vue&type=script&lang=js&"
import style0 from "./jsonSettings.vue?vue&type=style&index=0&id=72815db6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports